/**
 * Platform ekranlarinin bicimlendirme yardimcilari.
 *
 * `Intl` ornekleri MODUL SEVIYESINDE kuruluyor: her satirda yeni bir
 * `Intl.NumberFormat` uretmek uzun listelerde olculebilir bir maliyet. Dil
 * sabit 'tr-TR' — bu bicimlendiriciler METIN degil SAYI/TARIH bicimliyor,
 * yani ceviri katmanina bagli degiller.
 */

const dateTimeFormat = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateFormat = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const numberFormat = new Intl.NumberFormat('tr-TR');

const compactMoneyFormat = new Intl.NumberFormat('tr-TR', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** Bos/bozuk tarih BOS DIZE doner — "Invalid Date" ekranda gorunmemeli. */
export const formatDateTime = (value: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateTimeFormat.format(date);
};

export const formatDate = (value: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateFormat.format(date);
};

export const formatCount = (value: number): string => numberFormat.format(value);

/** Buyuk hacim degerleri icin kisa gosterim (1,2 Mn gibi). */
export const formatCompact = (value: number): string => compactMoneyFormat.format(value);

/** 0.775 -> "%77,5". Yuzde isareti Turkce'de SAYIDAN ONCE gelir. */
export const formatPercent = (ratio: number): string =>
  `%${numberFormat.format(Math.round(ratio * 1000) / 10)}`;
